
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.666 4h2.667c.889 0 1.333.444 1.333 1.333v8c0 .89-.444 1.333-1.333 1.333H6.666c-.888 0-1.333-.444-1.333-1.333V12H2.666c-.888 0-1.333-.445-1.333-1.334v-8c0-.888.445-1.333 1.333-1.333h6.667c.889 0 1.333.445 1.333 1.333V4zm-4 9.333h6.667v-8H6.666v8zm-1.333-2.667V5.333C5.333 4.444 5.778 4 6.666 4h2.667V2.666H2.666v8h2.667z","fill":"#CBD5E0"}})])
          )
        }
      }
    